module.exports = __webpack_public_path__ + "static/_200x200-b3f8b8236e1cc7d9e4d9b7403db9fd06.jpg";